import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import collaboratorAPI from '@infrastructure/collaborator-api';
export const createCollaboratorAsync = createAsyncThunk('collaborator/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await collaboratorAPI.createCollaborator(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCollaboratorAsync = createAsyncThunk('collaborator/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await collaboratorAPI.updateCollaborator(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllCollaboratorsAsync = createAsyncThunk('collaborator/getAll', async (payload, { rejectWithValue }) => {
    try {
        const response = await collaboratorAPI.getAllCollaborators(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCollaboratorByIdAsync = createAsyncThunk('collaborator/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await collaboratorAPI.getCollaboratorById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteCollaboratorAsync = createAsyncThunk('collaborator/delete', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await collaboratorAPI.deleteCollaborator(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const enableCollaboratorAsync = createAsyncThunk('collaborator/enable', async (id, { rejectWithValue }) => {
    try {
        const response = await collaboratorAPI.enableCollaborator(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const disableCollaboratorAsync = createAsyncThunk('collaborator/disable', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await collaboratorAPI.disableCollaborator(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCollaboratorsByEventAsync = createAsyncThunk('collaborator/getCollaboratorsByEvent', async ({ eventId, accessLevel }, { rejectWithValue }) => {
    try {
        const response = await collaboratorAPI.getCollaboratorsByEvent(eventId, accessLevel);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllCollaboratorsByCompanyAsync = createAsyncThunk('collaborator/getAllCollaboratorsByCompany', async (companyIds, { rejectWithValue }) => {
    try {
        const response = await collaboratorAPI.getAllCollaboratorsByCompany(companyIds);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
